import {
    useRef,
    useState
} from 'react'
import { useDialogContext } from '@shared/hooks/dialogContext'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useMethods } from '@shared/hooks/methods'
import imageCompression from 'browser-image-compression'

export const useFields = () => {
    const { showMessage } = useMethods()
    const {
        form: {
            watch,
            setValue,
            control
        },
        instance,
        handleClose,
        isPending,
        dialogMode,
        
        viewDocs,
        viewCropper
    } = useDialogContext()
    const urls = useRef([])
    const workType = watch('work_type')

    // tabs
    const [tab, setTab] = useState('general')
    
    // images
    const images = watch('images')
    const imgUploaderRef = useRef(null)

    const uploadImage = async (e) => {
        const files = Array.from(e.target.files)
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
        const validFiles = files.filter(file => allowedTypes.includes(file.type))

        if (validFiles.length === 0) return

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        try {
            const BATCH_SIZE = 3
            let allProcessedFiles = []
            for (let i = 0; i < validFiles.length; i += BATCH_SIZE) {
                const batch = validFiles.slice(i, i + BATCH_SIZE)
                showMessage({
                    text: `جارٍ ضغط الصور... (${Math.min(i + BATCH_SIZE, validFiles.length)} من ${validFiles.length})`,
                    loading: true
                })

                const batchResults = await Promise.all(
                    batch.map(async (file) => {
                        const compressedBlob = await imageCompression(file, options)
                        const compressedFile = new File([compressedBlob], file.name, {
                            type: compressedBlob.type || file.type,
                            lastModified: Date.now(),
                        })
                        const url = URL.createObjectURL(compressedFile)
                        return {
                            id: crypto.randomUUID(),
                            file: compressedFile,
                            url,
                            dep: tab
                        }
                    })
                )
                allProcessedFiles.push(...batchResults)
            }
            const newUrls = allProcessedFiles.map(item => item.url)
            urls.current = [...urls.current, ...newUrls]
            setValue('images', [...images, ...allProcessedFiles], { shouldDirty: true })

        } catch (error) {
            console.error('حدث خطأ أثناء ضغط الصور:', error)
            showMessage({ text: 'حدث خطأ أثناء معالجة الصور', loading: false })
        } finally {
            imgUploaderRef.current.value = null
            showMessage(null)
        }
    }

    // attachments
    const attachments = watch('attachments')
    const atchUploaderRef = useRef(null)

    const uploadAttachment = (e) => {
        const files = Array.from(e.target.files)
        const MAX_SIZE = 50 * 1024 * 1024 // 50 MB
        const validFiles = files.filter((file) => {
            if (file.type !== 'application/pdf') {
                showMessage({ text: 'ما اخترته ليس pdf.' })
                return false
            }
            if (file.size > MAX_SIZE) {
                showMessage({ text: 'حجم الملف كبير، الحد ٥٠ ميغابايت' })
                return false
            }
            return true
        })

        const newAttachments = validFiles.map((file) => {
            const url = URL.createObjectURL(file)
            urls.current = [...urls.current, url]
            return {
                id: crypto.randomUUID(),
                file,
                name: file.name,
                size: file.size,
                url
            }
        })

        setValue('attachments', [...attachments, ...newAttachments], { shouldDirty: true })
        atchUploaderRef.current.value = null
    }

    // fetch offices
    const offices = useRestFetch({
        key: ['offices'],
        endpoint: 'settings/offices/',
        retry: Infinity
    })

    return {
        instance,
        handleClose,
        isPending,
        workType,
        control,
        dialogMode,

        tab,
        setTab,

        viewDocs,
        viewCropper,

        images,
        imgUploaderRef,
        uploadImage,

        attachments,
        atchUploaderRef,
        uploadAttachment,

        offices
    }
}